<form id="form-checkout">
  <span class="p-float-label">
    <input
      id="form-checkout__cardNumber"
      [disabled]="disabled"
      (blur)="onComplete()"
      (keydown)="onKeydown()"
      pInputText
      ariaLabel="Número do cartão"
      name="cardNumber"
      [maxLength]="16"
      [ngModel]="card?.cardNumber"
      (ngModelChange)="updateCardField('cardNumber', $event)"
      [ngClass]="{
        'error-input': cardInputError?.errorCardNumber
      }"
    />
    <label
      htmlFor="cardNumber"
      [ngClass]="{
        disabled
      }"
      >Número do cartão</label
    >
    <img
      *ngIf="installments?.issuer?.thumbnail"
      [src]="installments?.issuer?.thumbnail"
      alt="Cartão de crédito."
    />
  </span>

  <span class="p-float-label">
    <input
      id="form-checkout__cardholderName"
      [disabled]="disabled"
      aria-label="Nome igual impresso no cartão"
      type="text"
      required
      name="name"
      pInputText
      [ngModel]="card?.name"
      (ngModelChange)="updateCardField('name', $event)"
      [ngClass]="{
        'error-input': cardInputError?.errorName
      }"
    />
    <label
      htmlFor="name"
      [ngClass]="{
        disabled
      }"
      >Nome igual impresso no cartão</label
    >
  </span>

  <div class="credit-card-inputs">
    <input
      id="form-checkout__expirationDate"
      aria-label="Data de expiração"
      placeholder="MM/AAAA"
      [maxLength]="7"
      [minlength]="7"
      [disabled]="disabled"
      type="text"
      required
      name="expiration"
      pInputText
      [ngModel]="card?.expirationDate"
      (ngModelChange)="updateCardField('expirationDate', $event)"
      [ngClass]="{
        'error-input': cardInputError?.errorExpirationDate
      }"
    />

    <input
      id="form-checkout__securityCode"
      [disabled]="disabled"
      aria-label="CVV"
      placeholder="CVV"
      type="text"
      required
      name="cvv"
      pInputText
      [ngModel]="card?.cvv"
      (ngModelChange)="updateCardField('cvv', $event)"
      [maxLength]="3"
      [ngClass]="{
        'error-input': cardInputError?.errorCvv
      }"
    />
  </div>

  <span class="p-float-label">
    <input
      id="form-checkout__identificationNumber"
      [disabled]="disabled"
      ariaLabel="CPF do titular do cartão"
      type="text"
      required
      name="document"
      maxlength="11"
      pInputText
      [ngModel]="card?.document"
      (ngModelChange)="updateCardField('document', $event)"
      [ngClass]="{
        'error-input': cardInputError?.errorDocument
      }"
    />
    <label
      htmlFor="document"
      [ngClass]="{
        disabled
      }"
      >CPF do titular do cartão</label
    >
  </span>

  <select
    class="form-control"
    id="form-checkout__installments"
    name="installments"
    type="text"
    [disabled]="disabled"
    [ngClass]="{
      'error-input': cardInputError?.errorInstallments
    }"
  >
    <option data-placeholder="" selected="" disabled="">
      Número de parcelas
    </option>
  </select>

  <input
    id="form-checkout__cardholderEmail"
    name="cardholderEmail"
    type="email"
    placeholder="Informe seu E-MAIL"
    type="hidden"
  />
  <select
    style="display: none"
    id="form-checkout__issuer"
    name="issuer"
  ></select>
  <select
    style="display: none"
    id="form-checkout__identificationType"
    name="identificationType"
  ></select>
</form>
